var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{staticClass:"secondary",on:{"click":_vm.copy}},[_c('BaseIcon',{attrs:{"name":_vm.copied ? 'check' : _vm.icon}}),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.copied ? 'URL Copied!' : _vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }